import Image from 'next/image';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { S3_ICONS_URL } from '~config/publicEnv';

interface Props {
  className?: string;
  iconSize?: number;
}

function ContentLoading({ className, iconSize = 36 }: Props) {
  return (
    <Container className={className}>
      <LoadingIcon
        src={`${S3_ICONS_URL}/ico_circle_gray_400_36x36.svg`}
        alt=""
        width={iconSize}
        height={iconSize}
        priority
      />
    </Container>
  );
}

export default ContentLoading;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoadingIcon = styled(Image)`
  animation: ${rotate} 1s linear infinite;
`;
